import * as React from 'react'
import type { AbstractClientLogger } from '../../../shared/lib/ClientLogger.no-deps'
import { Translations } from '../../../shared/i18n/Translations'
import { Base_PureComponent } from '../Base/Base.ui.Component'
import { UI_dialogClose, UI_dialogOpen } from '../UI/UI.Dialog'

const explanationMessage = () => Translations.t('app:Rpts.NoAccessToTaskWarning.description')

type TProps = {
    onOk: () => void
}

export class Rpts_NoAccessWarning extends Base_PureComponent<TProps, {}> {
    public tryRender() {
        const { onOk } = this.props

        return (
            <div className="reports_NoAccessWarning_root">
                <img src="res/no-access.svg" className="reports_NoAccessWarning_img" />
                <div className="reports_NoAccessWarning_heading">
                    {Translations.t('app:Rpts.NoAccessToTaskWarning.title')}
                </div>
                <div className="reports_NoAccessWarning_expl">{explanationMessage()}</div>
                <zaptic-button type={'secondary'} onClick={onOk} full-width={true}>
                    {Translations.t('app:UI.common.back')}
                </zaptic-button>
            </div>
        )
    }
}

/**
 * displays a Rpts_NoAccessWarning dialog, and awaits user response.
 */
export function Rpts_NoAccessWarningDialog(logger: AbstractClientLogger): Promise<void> {
    logger.warn('no access to procedure')

    return new Promise((resolve) => {
        UI_dialogOpen(
            {
                key: 'no-access-warning-dialog',
                contentStyle: { minWidth: '280px', maxWidth: 'calc(15px * 30 + 2 * 24px + 30px)' },
                onRequestClose: () => {
                    UI_dialogClose()
                    resolve()
                },
            },
            <Rpts_NoAccessWarning
                onOk={() => {
                    UI_dialogClose()
                    resolve()
                }}
            />
        )
    })
}
